import Stats from './stats.module.js';
import './interface.css';
import $ from 'jquery';
import React, {useEffect, useState} from "react";
import {bindWindowEvent} from "../viewer/events";
import {assetDrawerWidth} from "../asset-drawer";

export const DebugStats = props => {
  const assetDrawerState = props.assetDrawerState;
  const [stats, setStats] = useState(null);

  const removeOldElements = () => {
    try {
      document.getElementsByClassName("stats")[0].remove();
    } catch {
      // Nothing
    }
  };

  useEffect(() => {
    if (stats) {
      let margin = assetDrawerState ? -assetDrawerWidth/2 : 0;
      stats.element.css("margin-right", `${margin}px`);
    }
  }, [stats, assetDrawerState]);

  useEffect(() => {
    removeOldElements();
    let statsRef = new StatsPanel();
    setStats(statsRef);
  }, []);

  return (
    <div id="debug-placeholder"></div>
  );
};

class StatsPanel {
  private stats: any;
  private statsTotalPanels: any;
  private pointsVisible: any;
  private nodesVisible: any;

  constructor() {
    this.statsTotalPanels = 3;

    this.addStatsPanel();
    this.initStatsEvents();
  }

  get element() {
    return $(this.stats.dom);
  }

  addStatsPanel() {
    this.stats = new Stats();
    $(this.stats.dom).addClass("stats");

    this.pointsVisible = this.stats.addPanel(new Stats.Panel('pts', '#ff8', '#221'));
    this.nodesVisible = this.stats.addPanel(new Stats.Panel('nodes', '#f8f', '#212'));

    let childCount = this.stats.dom.children.length;
    this.stats.dom.children[childCount - 2].style.display = 'inline-block';
    this.stats.dom.children[childCount - 1].style.display = 'inline-block';
    this.stats.dom.children[0].style.display = 'inline-block';
    document.getElementsByTagName("body")[0].appendChild(this.stats.dom);

    // Clicking will toggle the next 3 items
    $(this.stats.dom).on("click", () => {
      let itemSelected = 0;
      let children = this.stats.dom.children;
      for (var i = 0; i < children.length; i++) {
        if (children[i].style.display === "block") {
          itemSelected = i;
        }

        children[i].style.display = "none";
      }

      let modulus = this.stats.dom.children.length;
      for (var j = itemSelected; j < (itemSelected + this.statsTotalPanels); j++) {
        this.stats.dom.children[j % modulus].style.display = 'inline-block';
      }
    });
  }

  initStatsEvents() {
    bindWindowEvent("stats.begin", () => {
      this.stats.begin();
    });

    bindWindowEvent("stats.end", (event, data) => {
      this.pointsVisible.update(data.visible_points / 1000,
        data.max_points / 1000);
      this.nodesVisible.update(data.number_nodes, 500);
      this.stats.end();
    });
  }
}
